import { createUseStyles } from 'react-jss';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const GILROY = '"Picsart-Fonts", sans-serif';

const useStyles = createUseStyles(
  {
    wrapper: {
      position: 'relative',
    },
    avatarBtn: {
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: CornerRadius.circle,
    },
    dropdown: {
      position: 'absolute',
      top: 'calc(100% + 8px)',
      right: 0,
      width: 260,
      backgroundColor: BackgroundColors.base,
      border: `1px solid ${BackgroundColors.border}`,
      borderRadius: CornerRadius.r12,
      zIndex: 600,
      overflow: 'hidden',
      boxShadow: '0 8px 24px rgba(0,0,0,0.24)',
    },
    userCard: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s4,
      padding: Spacings.s8,
    },
    userInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      minWidth: 0,
    },
    userName: {
      fontFamily: GILROY,
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l24,
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    userHandle: {
      fontFamily: GILROY,
      fontSize: FontSizes.s14,
      lineHeight: LineHeights.l20,
      opacity: 0.75,
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  { name: 'UserMenuButton' }
);

export default useStyles;
